import { IconButton } from '../icon-button/IconButton';
import { withPersonalizedIconButtonStyle } from '../icon-button/withPersonalizedIconButtonStyle';
import { styles } from './IconQuaternaryOnLightButton.styles';

export const IconQuaternaryOnLightButton = withPersonalizedIconButtonStyle(IconButton, styles);
